import type { AgentMode } from '@tabbio/types';
import { api } from './api';
import { getThreadRequestOptions } from './agent-threads';

export type MessageFeedbackValue = 'up' | 'down';

export async function setMessageFeedback(
  threadId: string,
  messageId: string,
  rating: MessageFeedbackValue,
  mode: AgentMode,
  companyId?: string,
): Promise<void> {
  const res = await api.put<{ messageId: string; rating: MessageFeedbackValue }>(
    `/api/agent/threads/${threadId}/messages/${messageId}/feedback`,
    { rating },
    getThreadRequestOptions(mode, companyId),
  );
  if (res.error) throw new Error(res.error.message);
}

export async function clearMessageFeedback(
  threadId: string,
  messageId: string,
  mode: AgentMode,
  companyId?: string,
): Promise<void> {
  const res = await api.delete<{ messageId: string; rating: null }>(
    `/api/agent/threads/${threadId}/messages/${messageId}/feedback`,
    getThreadRequestOptions(mode, companyId),
  );
  if (res.error) throw new Error(res.error.message);
}
